import { createMuiTheme } from "@material-ui/core/styles";

const Theme = createMuiTheme({
	palette: {
		primary: {
			main: "#0064F9",//"#31A6FF",
			contrastText: "#fff"
		},
		secondary: {
			main: "#000",
			contrastText: "#fff"
		},
		warning: {
			main: "#ff9800"
		}
	},
	overrides: {
		MuiBox: {
			root: {
				padding: 0
			}
		},
		MuiButton: {
			root: {
				minWidth: "100px"
			}
		},
		MuiInput:{
			fieldset:{
				borderColor:"#281D4D"
			}
		},
		MuiTabs: {
			root: {
				marginBottom: "10px"
			},
			flexContainer: {
				background: "#f8f8f8"
			},
			indicator: {
				height: "5px"
			},
		},
		MuiTab: {
			textColorInherit: {
				opacity: "1"
			}
			// wrapper: {
			//   color: "#97D95B"
			// }
		},
		MuiSvgIcon:{
			colorPrimary: {
				color: "#E66D1C"
			}
		},
		MuiIcon: {
			colorPrimary: {
				color: "#E66D1C"
			}
		},
		MuiPaper: {
			elevation4: {
				boxShadow: "none"
			}
		},
		MuiTypography: {
			// h5: {
			// 	fontSize: "14pt",
			// 	fontWeight: "bold"
			// }
		},
		MuiFormGroup: {
			root: {
				flexWrap: "initial"
			}
		},
		MuiFormControl: {
			root: {
				width: "100%"
			}
		},
	}
});


export default Theme;
